<div fxLayoutAlign="center center" style="margin-top: 1em;">
  <div fxFlex="80" fxLayoutAlign="center center" fxLayoutGap="5%">
    <img src="/assets/i/general.jpg" fxFlex="50">
    <div fxFlex="50">
      <h2>General Law</h2>
      <p>Not everything falls into a clear cut category, and we are able to help you navigate idiosyncratic or unusual legal situations you may find yourself in. While we do limit our representation to civil and not criminal matters, we are happy to discuss cases that don't fit squarely into our established practice areas.</p>
    </div>
  </div>
</div>
